import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index/index.vue'
import timeLine from '../views/timeLine/index.vue'
import rank from '../views/rank/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: index
  },
  {
    //时间轴页面
    path: '/timeLine',
    name: 'timeLine',
    component: timeLine
  },
  {
    //排行榜
    path: '/rank',
    name: 'rank',
    component: rank
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  routes
})

export default router
